import '../styles/globals.css'
import type { AppProps } from 'next/app'
import React from 'react'
import { AwazeThemeProvider } from '@awazevr/design-system.components.awaze-theme-provider'
import { InterstitialPopup } from '../src/components/InterstitialPopup'
import { StyleSheetManager } from 'styled-components'
import { shouldForwardProp } from '../src/utils/should-forward-props'
import { Brand } from '@awazevr/design-system.components.awaze-theme-provider'

if (
  process.env.NEXT_PUBLIC_API_MOCKING === 'enabled' &&
  process.env.APP_ENV !== 'prd'
) {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { initMocks } = require('../mocks')
  await initMocks()
}

const MyApp: React.FC<AppProps> = ({ Component, pageProps }: AppProps) => {
  const brand =
    pageProps.awazeHttpHeaders?.brand || pageProps.brand || 'cottages.com'

  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <AwazeThemeProvider brand={brand as Brand}>
        <InterstitialPopup
          brand={brand}
          interstitialPageData={pageProps.interstitialPageData}
        />
        <Component {...pageProps} />
      </AwazeThemeProvider>
    </StyleSheetManager>
  )
}

export default MyApp
